import React from "react";

const TermsAndConditions = () => {
  return (
    <div
      style={{
        maxWidth: "900px",
        margin: "0 auto",
        padding: "30px 20px",
        lineHeight: "1.7",
        color: "#333",
        textAlign: "left",
      }}
    >
      <h1
        style={{
          marginBottom: "20px",
          fontSize: "2rem",
          color: "#222",
          fontWeight: "600",
          textAlign: "left",
        }}
      >
        Terms & Conditions – Speak Bold with KK
      </h1>

      <p>
        By accessing or using <strong>Speak Bold with KK</strong> website,
        mobile application, or services, you agree to the following Terms and
        Conditions. Please read them carefully.
      </p>

      <h2
        style={{
          marginTop: "30px",
          fontSize: "1.4rem",
          textAlign: "left",
        }}
      >
        Services Offered
      </h2>
      <p>
        Speak Bold with KK provides online communication training, group
        discussions, interview preparation, and premium content for learners
        seeking to improve their English-speaking skills and confidence.
      </p>

      <h2
        style={{
          marginTop: "30px",
          fontSize: "1.4rem",
          textAlign: "left",
        }}
      >
        User Responsibilities
      </h2>
      <ul style={{ paddingLeft: "20px" }}>
        <li>You must provide accurate and up-to-date information.</li>
        <li>You agree not to misuse, copy, or redistribute our content.</li>
        <li>
          You must follow session guidelines and maintain respectful behavior.
        </li>
      </ul>

      <h2
        style={{
          marginTop: "30px",
          fontSize: "1.4rem",
          textAlign: "left",
        }}
      >
        Payments
      </h2>
      <p>
        All payments for sessions or premium content are processed securely
        through <strong>Razorpay</strong>. Speak Bold with KK does not store or
        handle your payment card details.
      </p>

      <h2
        style={{
          marginTop: "30px",
          fontSize: "1.4rem",
          textAlign: "left",
        }}
      >
        Content Usage
      </h2>
      <p>
        All learning materials, videos, text, images, and digital content are
        the intellectual property of Speak Bold with KK. Unauthorized copying,
        distribution, or commercial use is strictly prohibited.
      </p>

      <h2
        style={{
          marginTop: "30px",
          fontSize: "1.4rem",
          textAlign: "left",
        }}
      >
        Modifications
      </h2>
      <p>
        Speak Bold with KK may update or modify these Terms at any time.
        Continued use of our services signifies acceptance of the updated Terms.
      </p>

      <h2
        style={{
          marginTop: "30px",
          fontSize: "1.4rem",
          textAlign: "left",
        }}
      >
        Contact Us
      </h2>
      <p>
        If you have any questions regarding these Terms, you can reach us at:
      </p>

      <p>
        <strong>Email:</strong> support@speakboldwithkk.com
      </p>
    </div>
  );
};

export default TermsAndConditions;
